<template>
  <el-tooltip placement="top">
    <div slot="content" style="text-align: center;">로테이션 구분이 [보이기/숨기기]인 위젯 중에서<br />선택 된 로테이션 번호에 해당하는 위젯만 보여줍니다.</div>
    <el-select v-model="rotationNumbers" multiple collapse-tags placeholder="로테이션 번호" style="width: 120px;">
      <el-option
      v-for="item in rotationList"
      :key="item.rotationNumber"
      :label="item.rotationName"
      :value="item.rotationNumber">
    </el-option>
  </el-select>
</el-tooltip>
</template>

<script>
import DashboardConst from '@/constants/dashboard';

export default {
  name: 'WRotationVisibleSelect',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    rotationList() {
      const list = [];
      for (let i = DashboardConst.ROTATION.MIN; i <= DashboardConst.ROTATION.MAX; i += 1) {
        list.push({
          rotationNumber: i,
          rotationName: `${i} 번`,
        });
      }
      return list;
    },
    rotationNumbers: {
      get() {
        return this.$store.getters.getEditFilterRotationIds;
      },
      set(value) {
        this.$store.commit('setEditFilterRotationIds', value);
      },
    },
  },
  methods: {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/RotationVisibleSelect.vue